// ----------------------------------------------------------------------

export default function getFileData(file, index, awsEndpointUrl) {
  if (typeof file === 'string') {
    return {
      key: index ? `${file}-${index}` : file,
      preview: `${awsEndpointUrl}/${file}`,
    };
  }

  return {
    key: index ? `${file.name}-${index}` : file.name,
    name: file.name,
    size: file.size,
    path: file.path,
    type: file.type,
    preview: file.preview,
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
  };
}
